export default __webpack_public_path__ + "content/61dca392b82e35c0b81a3fcfa545473a.png";